<app-abstract-dialog class="confirmation-dialog" [dialogWidth]="'800'"
                     [playButtonActive]="true"
                     [ttsIconState]="ttsIconState"
                     [repeatButtonActive]="repeatButtonActive"
                     (readTextEvent)="readText()"
                     (playAudioEvent)="playAudio()"
                     (closeEvent)="onCloseDialog()">

    <ng-container abstract-header>
        <mat-icon class="abstract-dialog__header__icon material-icons-round"
                  [class.warning]="dialogData.iconColor === 'warning'"
                  [class.info]="dialogData.iconColor === 'info'">{{dialogData.icon}}</mat-icon>
        <h3 class="abstract-dialog__header__title">{{dialogData.title}}</h3>
    </ng-container>

    <ng-container abstract-content>
        <p class="abstract-dialog__content__text">
            {{dialogData.content}}
        </p>
    </ng-container>

    <ng-container abstract-footer>
        <div class="abstract-dialog__footer__buttons-wrapper">
            <div class="abstract-dialog__footer__buttons-wrapper__btn-box">
                <app-button
                        [cssClasses]="'small outlined outlined__gray-07'"
                        [ariaLabel]="dialogData.leftButtonText + ('GENERAL.BUTTON' | translate)"
                        (buttonClicked)="onCloseDialog()">
                    {{dialogData.leftButtonText}}
                </app-button>
            </div>
            <div class="abstract-dialog__footer__buttons-wrapper__btn-box">
                <app-button
                        [cssClasses]="'small solid__blue-07'"
                        [ariaLabel]="dialogData.rightButtonText + ('GENERAL.BUTTON' | translate)"
                        (buttonClicked)="onConfirmAction()">
                    {{dialogData.rightButtonText}}
                </app-button>
            </div>
        </div>
    </ng-container>
</app-abstract-dialog>